"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _superagent = require("superagent");

var _superagent2 = _interopRequireDefault(_superagent);

var _queryString = require("query-string");

var _queryString2 = _interopRequireDefault(_queryString);

var _jwtDecode = require("jwt-decode");

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _store = require("store");

var _store2 = _interopRequireDefault(_store);

var _storePluginsExpire = require("store/plugins/expire");

var _storePluginsExpire2 = _interopRequireDefault(_storePluginsExpire);

var _constants = require("./constants");

var _fakeToken = require("./fakeToken");

Object.defineProperty(exports, "createFakeApiToken", {
    enumerable: true,
    get: function get() {
        return _fakeToken.createFakeApiToken;
    }
});
Object.defineProperty(exports, "createFakeAppToken", {
    enumerable: true,
    get: function get() {
        return _fakeToken.createFakeAppToken;
    }
});

var parseError = function parseError(err, res, treat200AsOk) {
    var error = {
        error: err,
        reason: _constants.ERROR_REASONS.UNKNOWN,
        response: res
    };

    if (err) {
        if (err.response) {
            if (err.response.body && err.response.body.reason) {
                error.reason = err.response.body.reason;
            } else if (err.response.statusCode === 401) {
                error.reason = _constants.ERROR_REASONS.NOT_AUTHENTICATED;
            } else if (err.response.statusCode === 403) {
                error.reason = _constants.ERROR_REASONS.NOT_AUTHORIZED;
            }
        }

        return error;
    }

    if (res && res.body && res.body.ok != true && (res.statusCode != 200 || !treat200AsOk)) {
        error.reason = res.body.reason || _constants.ERROR_REASONS.NOT_AUTHENTICATED;

        return error;
    }
};

var ErgAuthService = (function () {
    function ErgAuthService() {
        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

        _classCallCheck(this, ErgAuthService);

        this.DEFAULT_OPTIONS = {
            autoRefresh: true,
            appUrl: window.location.origin,
            appId: null,
            cookieName: "JWT",
            idService: "http://id.ergeon.in/",
            refreshUrl: "api/auth/jwt/request/",
            refreshBefore: 60 * 10, // refresh 10 minutes before token expires
            requiredRoles: [],
            TLD: document.location.hostname.split(".").slice(-1)[0].split(":")[0],
            mode: "web",
            clientId: null,
            firebasePersistenceType: null,
            ignoreConnectionError: false,
            otpRequestUrl: "api/auth/otp/request/",
            otpUseUrl: "api/auth/otp/use/",
            otpExchangeWithOtTokenUrl: "api/auth/otp/exchange-with-token/", // OtToken = One Time token
            authenticateWithOtTokenUrl: "api/auth/otp/use-token/", // OtToken = One Time token
            otpRevokeURL: "api/auth/refresh/revoke/",
            requestLogoutOtTokenUrl: "api/auth/request-logout-token/",
            logoutUrl: "api/auth/logout/",
            storeNamespace: "ergeon_auth",
            level: "development",
            mockJWT: null
        };

        if (options.level !== "production") {
            window._ergAuth = this;
            this._debug = true;
        }

        this._refreshEvent = new Event(_constants.EVENTS.REFRESH);

        if (options.firebaseRef && options.userDetailsEndpoint) {
            throw new Error("Must pass either `firebaseRef` or `userDetailsEndpoint` to options, not both.");
        }
        var baseCookieName = undefined;
        if (options.level === "staging") {
            baseCookieName = "JWT_staging";
        } else if (options.level === "development") {
            baseCookieName = "JWT_local";
        } else {
            baseCookieName = "JWT";
        }

        if (!options.appId) {
            throw new Error("Must initialize ErgAuthService with `appId` as one of the options.");
        }
        this.DEFAULT_OPTIONS.authenticateUrl = options.idService + "authorize/" + options.appId + "/";
        var commonApiParams = "app=" + options.appId + "&client_id=" + options.clientId;
        this.DEFAULT_OPTIONS.refreshUrl = this.DEFAULT_OPTIONS.refreshUrl + "?" + commonApiParams;
        if (options.firebaseRef) {
            this.DEFAULT_OPTIONS.cookieName = baseCookieName + "_" + options.appId;
            this.DEFAULT_OPTIONS.storeTokenName = "accessToken_" + options.appId;
            this.DEFAULT_OPTIONS.storeTokenIAT = "accessTokenIAT_" + options.appId;
            this._getUser = this._getFirebaseUser;
        } else {
            this.DEFAULT_OPTIONS.cookieName = "" + baseCookieName;
            this.DEFAULT_OPTIONS.storeTokenName = "accessToken";
            this.DEFAULT_OPTIONS.storeTokenIAT = "accessTokenIAT";
            this._getUser = this._getRestAPIUser;
        }

        var otpRequestPath = options.otpRequestUrl || this.DEFAULT_OPTIONS.otpRequestUrl;
        var otpRequestBaseUrl = "" + options.idService + otpRequestPath;
        this.DEFAULT_OPTIONS.otpRequestUrl = otpRequestBaseUrl + "?" + commonApiParams;

        var otpUseBaseUrl = "" + options.idService + this.DEFAULT_OPTIONS.otpUseUrl;
        this.DEFAULT_OPTIONS.otpUseUrl = otpUseBaseUrl + "?" + commonApiParams;

        var otpExchangeWithOtTokenBaseUrl = "" + options.idService + this.DEFAULT_OPTIONS.otpExchangeWithOtTokenUrl;
        this.DEFAULT_OPTIONS.otpExchangeWithOtTokenUrl = otpExchangeWithOtTokenBaseUrl + "?" + commonApiParams;

        var authenticateWithOtTokenBaseUrl = "" + options.idService + this.DEFAULT_OPTIONS.authenticateWithOtTokenUrl;
        this.DEFAULT_OPTIONS.authenticateWithOtTokenUrl = authenticateWithOtTokenBaseUrl + "?" + commonApiParams;

        var otpRevokeBaseUrl = "" + options.idService + this.DEFAULT_OPTIONS.otpRevokeURL;
        this.DEFAULT_OPTIONS.otpRevokeURL = otpRevokeBaseUrl + "?" + commonApiParams;

        var requestLogoutOtTokenBaseUrl = "" + options.idService + this.DEFAULT_OPTIONS.requestLogoutOtTokenUrl;
        this.DEFAULT_OPTIONS.requestLogoutOtTokenUrl = requestLogoutOtTokenBaseUrl + "?" + commonApiParams;

        var logoutBaseUrl = "" + options.idService + this.DEFAULT_OPTIONS.logoutUrl;
        this.DEFAULT_OPTIONS.logoutUrl = logoutBaseUrl + "?" + commonApiParams;

        this.options = _extends({}, this.DEFAULT_OPTIONS, options);

        var allowedModes = ["web", "otp"];
        if (allowedModes.indexOf(this.options.mode) === -1) {
            throw new Error("Mode must be one of " + allowedModes + ", got " + this.options.mode + ".");
        }

        if (this.options.autoRefresh === true) {
            setInterval(this.autoRefresh.bind(this), 60 * 1000); // check expiry every minute
        }
        this.localStorage = _store2["default"].namespace(this.options.storeNamespace);
        this.localStorage.addPlugin(_storePluginsExpire2["default"]);
    }

    _createClass(ErgAuthService, [{
        key: "debug",
        value: function debug() {
            if (this._debug) {
                var message = "";
                for (var i = 0; i < arguments.length; i++) {
                    message += arguments[i];
                }
                console.debug("[erg-utils-js]", message);
            }
        }
    }, {
        key: "authenticate",
        value: function authenticate() {
            var nextUrl = arguments.length <= 0 || arguments[0] === undefined ? window.location.href : arguments[0];
            var skipLogin = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

            if (this.options.mode === "otp") {
                return this.refreshToken();
            }
            var getParams = { "next": encodeURIComponent(nextUrl) };
            if (skipLogin) {
                getParams["skip-login"] = "true";
            }
            var stringified = _queryString2["default"].stringify(getParams);
            var newLocation = this.options.authenticateUrl + "?" + stringified;
            window.location = newLocation;
        }
    }, {
        key: "getUser",
        value: function getUser(callback) {
            var token = this.getToken();
            if (!token) {
                callback({
                    reason: _constants.ERROR_REASONS.MISSING_TOKEN
                });
            } else {
                this._getUser(token, callback);
            }
        }
    }, {
        key: "_getFirebaseUser",
        value: function _getFirebaseUser(token, callback) {
            var _this = this;

            if (!this.options.firebaseRef) {
                throw new Error("Must initialize ErgAuthService with `firebaseRef` as one of the options.");
            }

            var payload = this.getPayload(token);
            var missingRole = this.options.requiredRoles.find(function (role) {
                return payload.claims[role] != true;
            });
            if (missingRole) {
                callback({ reason: _constants.ERROR_REASONS.NOT_AUTHORIZED }, null);
                return;
            }

            var signIn = function signIn() {
                _this.options.firebaseRef.signInWithCustomToken(token).then(function (authData) {
                    return callback(null, _extends({
                        authData: authData,
                        name: payload.first_name + " " + payload.last_name
                    }, payload));
                },
                // error
                function (err) {
                    return callback(err, null);
                });
            };

            if (this.options.firebasePersistenceType) {
                this.options.firebaseRef.setPersistence(this.options.firebasePersistenceType).then(signIn);
            } else {
                signIn();
            }
        }
    }, {
        key: "_getRestAPIUser",
        value: function _getRestAPIUser(token, callback) {
            if (!this.options.userDetailsEndpoint) {
                throw new Error("Must initialize ErgAuthService with `userDetailsEndpoint` as one of the options.");
            }

            _superagent2["default"].post(this.options.userDetailsEndpoint).send({ token: token }).set("Authorization", this.getAuthHeader()).set("Accept", "application/json").end(function (err, res) {
                var error = parseError(err, res);

                if (error) {
                    callback(error, null);
                } else {
                    callback(null, res.body.user);
                }
            });
        }
    }, {
        key: "autoRefresh",
        value: function autoRefresh() {
            this.debug("Autorefresh called");
            var token = this.getToken();
            var payload = this.getPayload(token);
            if (!payload) {
                this.emitRefresh();
                return;
            }

            if (this.isExpired(payload)) {
                this.debug("Token expired: Logging out");
                this.emitRefresh();
            }
            if (this.willExpireSoon(payload)) {
                this.debug("Calling refresh token");
                this.refreshToken(token);
            }
        }
    }, {
        key: "isExpired",
        value: function isExpired(tokenPayload) {
            var now = new Date().getTime() / 1000;
            var expires = tokenPayload["exp"];
            return now >= expires;
        }
    }, {
        key: "willExpireSoon",
        value: function willExpireSoon(tokenPayload) {
            var now = new Date().getTime() / 1000;
            var expires = tokenPayload["exp"];
            return now >= expires - this.options.refreshBefore;
        }
    }, {
        key: "refreshToken",
        value: function refreshToken() {
            var _this2 = this;

            var currentToken = arguments.length <= 0 || arguments[0] === undefined ? this.getToken() : arguments[0];

            // Method will refresh *access* token
            this.debug("Refreshing token now");
            var request = new XMLHttpRequest();
            request.open("POST", this.options.idService + this.options.refreshUrl, true);
            request.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
            request.setRequestHeader("Accept", "application/json");
            request.setRequestHeader("Authorization", this.getAuthHeader(currentToken));
            request.send();

            return new Promise(function (resolve, reject) {
                request.onload = (function () {
                    if (request.status == 200) {
                        var newToken = JSON.parse(request.responseText)["jwt"][this.options.appId];
                        this.setToken(newToken);
                    }
                    this.emitRefresh();
                    resolve();
                }).bind(_this2);

                request.onerror = (function () {
                    if (!this.options.ignoreConnectionError) {
                        this.debug("Error while trying to refresh token, trying again in some time");
                        setTimeout(this.refreshToken.bind(this, currentToken), 60 * 1000);
                    }
                    reject();
                }).bind(_this2);
            });
        }
    }, {
        key: "getAuthHeader",
        value: function getAuthHeader() {
            var accessToken = arguments.length <= 0 || arguments[0] === undefined ? this.getToken() : arguments[0];

            if (this.options.mode === "otp") {
                return "REFRESH " + this.getRefreshToken();
            }
            return "JWT " + accessToken;
        }
    }, {
        key: "getToken",
        value: function getToken() {
            // return *access* token

            if (this.options.level === "development" && this.options.mockJWT) {
                return this.options.mockJWT;
            }
            if (this.options.mode === "otp") {
                return this.localStorage.get(this.options.storeTokenName);
            }
            return (document.cookie.match("(^|; )" + this.options.cookieName + "=([^;]*)") || 0)[2];
        }
    }, {
        key: "setToken",
        value: function setToken(accessToken) {
            this.debug("setToken(" + accessToken + ")");
            if (this.options.mode === "otp") {
                var payload = this.getPayload(accessToken);
                this.localStorage.set(this.options.storeTokenName, accessToken, payload["exp"] * 1000);
                this.localStorage.set(this.options.storeTokenIAT, payload["iat"] * 1000);
            } else {
                var cookieName = this.options.cookieName;
                document.cookie = cookieName + "=" + accessToken + "; domain=.ergeon." + this.options.TLD + "; path=/";
            }
        }
    }, {
        key: "getRefreshToken",
        value: function getRefreshToken() {
            if (this.options.mode === "otp") {
                return this.localStorage.get("refreshToken");
            }
            throw new Error("Refresh Token is only supported in 'otp' mode");
        }
    }, {
        key: "setRefreshToken",
        value: function setRefreshToken(refreshToken) {
            if (this.options.mode === "otp") {
                this.localStorage.set("refreshToken", refreshToken);
            } else {
                throw new Error("Refresh Token is only supported in 'otp' mode");
            }
        }
    }, {
        key: "getPayload",
        value: function getPayload(token) {
            try {
                return (0, _jwtDecode2["default"])(token);
            } catch (err) {
                return null;
            }
        }
    }, {
        key: "emitRefresh",
        value: function emitRefresh() {
            this.debug("Got new token");
            document.dispatchEvent(this._refreshEvent);
        }
    }, {
        key: "otpRequest",
        value: function otpRequest(phoneNumber, callback) {
            _superagent2["default"].post(this.options.otpRequestUrl).send({ "phone_number": phoneNumber }).end(function (err, res) {
                var error = parseError(err, res, true);
                if (error) {
                    callback(error, null);
                } else {
                    callback(null, res.body.request_id);
                }
            });
        }
    }, {
        key: "otpUse",
        value: function otpUse(requestId, otp, callback) {
            var _this3 = this;

            _superagent2["default"].post(this.options.otpUseUrl).send({ "request_id": requestId, "code": otp }).end(function (err, res) {
                var error = parseError(err, res, true);
                if (error) {
                    callback(error, null);
                } else {
                    var accessToken = res.body.jwt[_this3.options.appId];
                    var refreshToken = res.body.refresh_token;
                    _this3.setToken(accessToken);
                    _this3.setRefreshToken(refreshToken);
                    callback(null, accessToken, refreshToken);
                }
            });
        }
    }, {
        key: "otpExchangeWithOneTimeToken",
        value: function otpExchangeWithOneTimeToken(requestId, otp, callback) {
            _superagent2["default"].post(this.options.otpExchangeWithOtTokenUrl).send({ "request_id": requestId, "code": otp }).end(function (err, res) {
                var error = parseError(err, res, true);
                if (error) {
                    callback(error, null);
                } else {
                    var oneTimeToken = res.body.one_time_token;
                    callback(null, oneTimeToken);
                }
            });
        }
    }, {
        key: "authenticateWithOneTimeToken",
        value: function authenticateWithOneTimeToken(oneTimeToken) {
            var nextUrl = arguments.length <= 1 || arguments[1] === undefined ? window.location.href : arguments[1];

            var getParams = { "next": encodeURIComponent(nextUrl), "token": oneTimeToken };
            var stringified = _queryString2["default"].stringify(getParams);
            var newLocation = this.options.authenticateWithOtTokenUrl + "&" + stringified;
            window.location = newLocation;
        }
    }, {
        key: "getAccessTokenIat",
        value: function getAccessTokenIat() {
            if (this.options.mode == "otp") {
                return this.localStorage.get(this.options.storeTokenIAT);
            }
            var accessToken = this.getToken();
            if (accessToken) {
                var payload = this.getPayload(accessToken);
                return payload && payload["iat"];
            }
        }
    }, {
        key: "logout",
        value: function logout(nextUrl, skipRedirect, callback) {
            if (nextUrl === undefined) nextUrl = this.options.appUrl;

            var _this4 = this;

            if (skipRedirect === undefined) skipRedirect = false;

            this.debug("logging out");

            var firebaseRef = this.options.firebaseRef;
            var refreshToken = null;
            var signOutPromise = null;

            if (firebaseRef) {
                if (firebaseRef.unauth) {
                    // old version of firebase
                    firebaseRef.unauth();
                }
                if (firebaseRef.signOut) {
                    signOutPromise = firebaseRef.signOut();
                }
            }

            if (this.options.mode === "otp") {
                (function () {
                    refreshToken = _this4.getRefreshToken();
                    var localStorage = _this4.localStorage;
                    // we can't just call localStorage.clearAll(), because it will clear
                    // *all* keys. But we want to remove only keys from current namespace.
                    localStorage.each(function (value, key) {
                        if (localStorage.get(key)) {
                            // key exists in current namespace
                            localStorage.remove(key);
                        }
                    });
                })();
            } else if (!skipRedirect) {
                nextUrl = encodeURIComponent(this.options.authenticateUrl + "?next=" + nextUrl);
                window.location = this.options.idService + "accounts/logout/?next=" + nextUrl;
            }

            if (callback) {
                Promise.all([signOutPromise, refreshToken ? new Promise(function (resolve, reject) {
                    _this4.revokeRefreshToken(refreshToken, function (err) {
                        return err ? reject(err) : resolve();
                    });
                }) : null]).then(function () {
                    return callback(null);
                }, function (err) {
                    return callback(err);
                });
            }
        }
    }, {
        key: "requestLogoutToken",
        value: function requestLogoutToken(callback) {
            _superagent2["default"].post(this.options.requestLogoutOtTokenUrl).send({}).set("Authorization", this.getAuthHeader()).set("Accept", "application/json").end(function (err, res) {
                var error = parseError(err, res, true);
                if (error) {
                    callback(error, null);
                } else {
                    var oneTimeToken = res.body.one_time_token;
                    callback(null, oneTimeToken);
                }
            });
        }
    }, {
        key: "logoutWithoutInteraction",
        value: function logoutWithoutInteraction(oneTimeToken) {
            var nextUrl = arguments.length <= 1 || arguments[1] === undefined ? this.options.appUrl : arguments[1];

            var getParams = { "next": encodeURIComponent(nextUrl), "token": oneTimeToken };
            var stringified = _queryString2["default"].stringify(getParams);
            var newLocation = this.options.logoutUrl + "&" + stringified;
            this.debug("Redirecting to", newLocation);
            window.location = newLocation;
        }
    }, {
        key: "revokeRefreshToken",
        value: function revokeRefreshToken(refreshToken, callback) {
            _superagent2["default"].post(this.options.otpRevokeURL).send({ "token": refreshToken }).end(function (err, res) {
                var error = parseError(err, res, true);
                if (error) {
                    callback(error);
                } else {
                    callback(null);
                }
            });
        }
    }, {
        key: "on",
        value: function on(event, callback) {
            document.addEventListener(_constants.EVENT_PREFIX + ":" + event, callback);
        }
    }, {
        key: "off",
        value: function off(event, callback) {
            document.removeEventListener(_constants.EVENT_PREFIX + ":" + event, callback);
        }
    }]);

    return ErgAuthService;
})();

exports["default"] = ErgAuthService;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-auth/dist/index.js
 ** module id = 778
 ** module chunks = 0
 **/